<template>
    <div class="h-auto" v-bind:style="{ 'width': getWidth() }">
        <img @click="redirect" :src="getSource()" class="m-0 p-0 block border-0" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "v-icon",
    props: {
        source: {
            type: String,
            required: true,
        },
        href: {
            type: String,
            required: false,
        },
        width: {
            type: Number,
            required: false,
            default: 24,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    methods: {
        getSource() {
            return require("@/assets/" + this.source);
        },
        redirect() {
            if(this.href != null && !this.disabled)
            {
                this.$router.push(this.href);
            }
        },   
        getWidth() {
            return this.width + 'px';
        },
    },
});
</script>